import { Observable } from 'rxjs';
import httpService from './httpService';
import { usePortalName } from '../hooks/usePortalName';

class MessagesService {
  private readonly apiBaseF1;
  private readonly apiPassengerBaseF1;

  constructor() {
    const { __environment__ } = window as any;
    const isPortal = usePortalName() ? true : false;
    // comms-center exposes SMS history under /messages; the env base URL does
    // not include it (comms-hub's does), so append it here.
    const commsCenterUrl =
      __environment__.REACT_APP_COMMS_CENTER_API_F1_URL.trim() + '/messages';
    const commsHubUrl = __environment__.REACT_APP_MESSAGES_API_F1_URL.trim();
    this.apiBaseF1 = isPortal ? commsCenterUrl : commsHubUrl;
    this.apiPassengerBaseF1 =
      __environment__.REACT_APP_PASSENGER_API_URL.trim();
  }
  public getPassengerDetails(
    page: number,
    pageSize: number,
    clientBC: string,
    searchText: string,
  ): Observable<any> {
    const url = `${this.apiPassengerBaseF1}?page=${page}&pageSize=${pageSize}&clientBC=${clientBC}&searchText=${searchText}`;
    return httpService.getJSON(url);
  }

  public getSmsAll(
    phoneNumber: string,
    page: number,
    pageSize: number,
  ): Observable<any> {
    const url = `${this.apiBaseF1}/sms/all?phoneNumber=${phoneNumber}&page=${page}&pageSize=${pageSize}`;
    return httpService.getJSON(url);
  }
}
const messageService = new MessagesService();

export default messageService;
